import { useParams, useNavigate, Outlet } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { togglePricingPlansDialog, usePricingPlans } from '@/hooks/usePricingPlans.jsx'
import { useVerifyPayment } from '@/hooks/useVerifyPayment.jsx'
import { PricingPlansDialog } from '@/components/pricing-plans/PricingPlansDialog'
import { VerifyPayment } from '@/pages/payment/paddle/VerifyPayment'
import AccountSelectorPage from '@/pages/account/AccountSelectorPage.jsx'
import { useEffect } from 'react'
import { useConfetti, toggleConfetti } from '@/hooks/useConfetti'
import Confetti from '@/components/confetti/Confetti'

export default function AccountDefault() {

    const { accountId } = useParams()
    const { accounts, logout } = useAuthContext()
    const navigate = useNavigate()
    const isPricingPlansDialogOpen = usePricingPlans()
    const isVerifyPaymentDialogOpen = useVerifyPayment()
    const isConfettiOn = useConfetti()

    useEffect(() => {
        // If no accounts, redirect to auth
        if (!accounts?.length) {
            logout()
            return
        }

        // Landing at /account with no account chosen yet.
        if (!accountId) {
            // Single account - skip the selector and go straight in.
            // Multiple accounts - render the selector below (no redirect).
            if (accounts.length === 1) {
                navigate(`/account/${accounts[0]._id}/space`)
            }
            return
        }

        const currentAccount = accounts.find(account => account._id === accountId)

        // An :accountId that isn't one of the user's accounts - bounce back to the
        // landing so the selector (or single-account redirect) resolves it.
        if (!currentAccount) {
            navigate('/account')
            return
        }

        // If we're exactly at /account/:accountId, redirect to the space route
        if (window.location.pathname === `/account/${accountId}`) {
            navigate(`/account/${accountId}/space`)
        }

    }, [accounts, accountId, navigate])


    if (!accounts?.length) {
        return null
    }

    // Multi-account user landed at /account without choosing yet - let them pick.
    if (!accountId && accounts.length > 1) {
        return <AccountSelectorPage />
    }

    return (
        <div>
            <Confetti active={isConfettiOn} onComplete={() => toggleConfetti(false)} />
            <PricingPlansDialog isOpen={isPricingPlansDialogOpen} setIsOpen={() => togglePricingPlansDialog(false)} />
            {isVerifyPaymentDialogOpen && <VerifyPayment />}
            <Outlet />
        </div>
    )
}